import axios from '@/utils/http'

/**
 *
 * 获取订单总体信息
 * @export
 * @param {*} params
 * @returns
 */
export function GetOrderBaseInfo(params) {
  return axios({
    url: '/MenuService/MenuManage/GetAllOrderStatistics',
    method: 'get',
    params: {
      ...params
    }
  })
}

/**
 *
 * 获取订单列表
 * @export
 * @param {*} params
 * @returns
 */
export function GetOrderList(params) {
  return axios({
    url: '/MenuService/MenuManage/GetAllOrderFoodList',
    method: 'get',
    params: {
      ...params
    }
  })
}

/**
 *
 * 获取订单详情
 * @export
 * @param {*} params
 * @returns
 */
export function GetOrderDetail(params) {
  return axios({
    url: '/MenuService/MenuManage/GetOrderFoodDetail',
    method: 'get',
    params: {
      ...params
    }
  })
}

/**
 *
 * 获取今日订单
 * @export
 * @param {*} params
 * @returns
 */
export function GetTodayOrderList(params) {
  return axios({
    url: '/MenuService/MenuManage/GetOrderStatistics',
    method: 'get',
    params: {
      ...params
    }
  })
}
